<template>
  <a-drawer
    title="站点订阅"
    placement="right"
    :width="700"
    :visible="visible"
    :maskClosable="false"
    @close="onClose"
  >
    <div class="drawer-container">
      <div class="condition-container">
        <!-- <div class="row">
          <div class="label">用户姓名：</div>
          <div class="input">
            <a-select
              style="width: 100%"
              v-model="activeSubscriberId"
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
            >
              <a-select-option
                v-for="(item, index) in userList"
                :key="index"
                :value="item.subscriberId"
              >
                {{ item.accountName }}
              </a-select-option>
            </a-select>
          </div>
        </div> -->
        <div class="row">
          <div class="label">站点名称：</div>
          <div class="input">
            <a-input v-model="spiderName" allowClear />
          </div>
        </div>
        <div class="row">
          <div class="label">国家/地区：</div>
          <div class="input">
            <CountrySelect v-model="countryCode" />
          </div>
        </div>
        <div class="row">
          <div class="label">站点类型：</div>
          <div class="input">
            <a-select style="width: 100%" v-model="spiderClassId" allowClear>
              <a-select-option
                v-for="(item, index) in siteClassList"
                :key="index"
                :value="item.spiderClassId"
              >
                {{ item.spiderClassName }}
              </a-select-option>
            </a-select>
          </div>
        </div>

        <div class="row" style="text-align: center">
          <div class="label"></div>
          <a-button type="primary" @click="() => search(true)">搜索</a-button>
          <a-button type="primary" @click="reset()" style="margin-left: 12px">重置</a-button>
        </div>
      </div>

      <div class="content">
        <div class="actions-container">
          <a-button type="primary" @click="cancelAll" v-if="isSelectAllInPage">一键取消</a-button>
          <a-button type="primary" @click="selectAll" v-else>一键全选</a-button>
          <span
            class="action"
            v-if="pagination.pageTotal && pagination.current !== pagination.pageTotal"
            @click="nextPage"
          >
            <a-icon type="redo" class="icon rotate-icon" />
            换一组
          </span>
          <span class="action" v-if="pagination.current !== 1" @click="prePage">
            <a-icon type="caret-left" class="icon" />
            上一组
          </span>
        </div>

        <a-empty style="margin: 40px auto" v-if="siteList.length === 0" />
        <div class="site-container">
          <SiteCell
            v-for="(site, index) in siteList"
            :key="index"
            :active="spiderIdSelectedList.includes(site.spiderId)"
            :name="site.spiderName"
            @click.native="onSelect(site)"
          />
        </div>

        <div class="submit-bt-row" v-if="siteList.length !== 0">
          <a-button type="primary" size="large" @click="save" :loading="saveLoading"
            >保存并退出</a-button
          >
        </div>
      </div>
    </div>
  </a-drawer>
</template>

<script>
import SiteCell from './SiteCell'
import CountrySelect from '@/components/CountrySelect/'
import { getSubscribeListByUserApi, saveSubscribeListByUserApi } from '@/api/Subscribe/site'
import { onHttpResponse, onHttpResponseSilent } from '../../../utils/request'
export default {
  components: { SiteCell, CountrySelect },
  props: {
    userList: Array,
    siteClassList: Array,
    onSubmit: Function
  },
  data() {
    return {
      visible: false,
      activeSubscriberId: '',
      spiderClassId: '',
      countryCode: '',
      spiderName: '',
      pagination: {
        current: 1,
        pageSize: 18,
        pageTotal: 0
      },

      siteList: [],
      selectedSites: [],

      saveLoading: false
    }
  },

  computed: {
    spiderIdSelectedList() {
      return this.selectedSites.map((s) => s.spiderId)
    },
    isSelectAllInPage() {
      let selectedIds = this.selectedSites.map((s) => s.spiderId)
      let pageIds = this.siteList.map((s) => s.spiderId)
      let selectedInPageIds = selectedIds.filter((s) => pageIds.includes(s))
      return selectedInPageIds.length && selectedInPageIds.length === pageIds.length
    }
  },
  methods: {
    reset() {
      this.activeSubscriberId = undefined
      this.countryCode = undefined
      this.spiderClassId = undefined
      this.spiderName = undefined
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },

    show(activeSubscriberId, spiderClassId) {
      this.visible = true
      this.spiderName = ''
      this.subscriberId = ''
      // this.activeSubscriberId = activeSubscriberId
      this.spiderClassId = this.siteClassList[1].spiderClassId
      this.search(true)
    },

    nextPage() {
      this.pagination.current++
      this.search(false)
    },

    prePage() {
      this.pagination.current--
      this.search(false)
    },

    search(clearSelect = false) {
      if (clearSelect) {
        this.selectedSites = []
      }
      let query = {
        pn: this.pagination.current,
        pageSize: this.pagination.pageSize,
        spiderClassType: this.siteClassList.filter(
          (site) => site.spiderClassId === this.spiderClassId
        )[0]?.type,
        spiderClassId: this.spiderClassId,
        countryCode: this.countryCode,
        subscriberId: this.activeSubscriberId
      }
      if (query.spiderClassId) {
        query.spiderName = this.spiderName
      }

      getSubscribeListByUserApi(query)
        .then(onHttpResponseSilent)
        .then(({ data, extra }) => {
          this.siteList = data
          this.pagination.pageTotal = extra.page.pageTotal
        })
    },

    onSelect(site) {
      if (this.spiderIdSelectedList.includes(site.spiderId)) {
        this.selectedSites = this.selectedSites.filter((s) => s.spiderId !== site.spiderId)
      } else {
        this.selectedSites.push(site)
      }
    },

    selectAll() {
      this.siteList.forEach((site) => {
        if (!this.spiderIdSelectedList.includes(site.spiderId)) {
          this.selectedSites.push(site)
        }
      })
    },

    cancelAll() {
      let pageIds = this.siteList.map((s) => s.spiderId)
      this.selectedSites = this.selectedSites.filter((s) => !pageIds.includes(s.spiderId))
    },

    onClose() {
      this.selectedSites = []
      this.visible = false
    },

    save() {
      this.saveLoading = true
      let type = this.siteClassList.find((site) => site.spiderClassId === this.spiderClassId)?.type
      saveSubscribeListByUserApi(
        this.selectedSites.map((site) => ({
          ...site,
          spiderExecType: site.execType,
          // subscriberId: this.activeSubscriberId,
          spiderClassType: type
        }))
      )
        .then(onHttpResponse)
        .then(() => {
          // this.onSubmit(this.activeSubscriberId, this.spiderClassId, this.spiderName)
          this.onSubmit()
          this.onClose()
        })
        .finally(() => {
          this.saveLoading = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.drawer-container {
  padding: 10px 25px;

  .condition-container {
    display: grid;
    grid-template-columns: 5fr 5fr;
    gap: 10px 20px;

    .row {
      display: flex;
      align-items: center;

      .label {
        width: 80px;
      }
      .input {
        flex: 1;
      }
    }
  }

  .content {
    width: 100%;
    margin-top: 40px;

    .actions-container {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      gap: 20px;

      .action {
        color: #1890ff;
        cursor: pointer;

        .icon {
          margin-right: 4px;
          transition: transform 1s;
        }

        &:hover {
          .rotate-icon {
            transform: rotate(360deg);
          }
        }
      }
    }

    .site-container {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 14px 18px;
      margin-top: 16px;
    }

    .submit-bt-row {
      margin-top: 30px;
      display: flex;
      justify-content: center;
    }
  }
}
</style>
